/**
 * Free gift disabled for product 45177829228726.
 * Keeps cart cleanup only — removes orphan gift items, never auto-adds gifts.
 */
(function () {
  var LOG = '[free gift 01 jul]';
  var FREE_GIFT_PROPERTY = '_free_gift';
  var GIFT_HANDLE = 'free-shaker';

  var giftVariantId = null;
  var giftProductId = null;
  var excludedProductId = null;
  var giftDiscountCode = null;
  var freeGiftEnabled = false;
  var processing = false;
  var ready = false;
  var lastKnownCart = null;
  var giftAddDisabled = false;

  function isGiftInventoryError(error) {
    var message = String(error?.description || error?.message || '').toLowerCase();
    return (
      message.indexOf('sold out') !== -1 ||
      message.indexOf('out of stock') !== -1 ||
      message.indexOf('not available') !== -1 ||
      message.indexOf('inventory') !== -1 ||
      message.indexOf('maximum quantity') !== -1
    );
  }

  function tryAddGiftToCart() {
    if (!freeGiftEnabled || giftAddDisabled || !giftVariantId || giftAlreadyInCart()) {
      return Promise.resolve(false);
    }

    var bundle = getCartSectionsToBundle();

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [
          {
            id: giftVariantId,
            quantity: 1,
            properties: { [FREE_GIFT_PROPERTY]: 'true' },
          },
        ],
        sections: bundle.sections.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) {
        return res.json().then(function (responseJson) {
          if (!res.ok) {
            if (isGiftInventoryError(responseJson)) {
              giftAddDisabled = true;
            }
            console.warn(
              LOG,
              'gift add skipped — main product will still be added:',
              responseJson?.description || responseJson?.message || responseJson
            );
            return false;
          }

          console.log(LOG, 'gift added to cart');
          return responseJson;
        });
      })
      .catch(function (error) {
        console.warn(LOG, 'gift add skipped:', error);
        return false;
      });
  }

  function completeMainProductAdd(form, mainResponseJson, mainVariantId) {
    if (
      window.themeVariables?.settings?.cartType === 'page' ||
      window.themeVariables?.settings?.pageType === 'cart'
    ) {
      window.location.href = window.Shopify.routes.root + 'cart';
      return Promise.resolve();
    }

    return refreshVariantAddedSection(mainResponseJson, mainVariantId).then(function (updatedResponse) {
      return finalizeCartAfterAdd(updatedResponse).then(function (cartContent) {
        console.log(LOG, 'main product added — item_count:', cartContent.item_count);
        return publishVariantAdd(form, updatedResponse, cartContent, 'variant:add');
      });
    });
  }

  function getTriggerVariantIdFromCart(cart) {
    var triggerItem = (cart?.items || []).find(function (item) {
      return !isGiftItem(item) && !isExcludedProduct(item);
    });
    return triggerItem?.variant_id || null;
  }

  function refreshVariantAddedSection(sectionsHolder, mainVariantId) {
    if (!mainVariantId || !sectionsHolder) {
      return Promise.resolve(sectionsHolder);
    }

    return fetch(
      window.Shopify.routes.root + 'variants/' + mainVariantId + '?sections=variant-added'
    )
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data['variant-added']) {
          sectionsHolder.sections = sectionsHolder.sections || {};
          sectionsHolder.sections['variant-added'] = data['variant-added'];
        }
        return sectionsHolder;
      })
      .catch(function () {
        return sectionsHolder;
      });
  }

  function updateCartNotificationFromVariantAdded(html) {
    if (!html || window.themeVariables?.settings?.cartType !== 'popover') {
      return;
    }

    var drawer = document.querySelector('cart-notification-drawer');
    if (!drawer) {
      return;
    }

    var tempContent = document.createElement('div');
    tempContent.innerHTML = html;
    var section = tempContent.querySelector('.shopify-section');

    if (!section) {
      return;
    }

    drawer.replaceChildren(...Array.from(section.children));

    if (drawer.open) {
      return;
    }

    drawer.show();
  }

  function getSetupEl() {
    return document.getElementById('free-gift-setup');
  }

  function isExcludedProduct(item) {
    if (!item || !excludedProductId) {
      return false;
    }

    return (
      String(item.product_id) === excludedProductId ||
      String(item.variant_id) === excludedProductId ||
      String(item.id) === excludedProductId
    );
  }

  function readConfig() {
    var setupEl = getSetupEl();
    var cfg = window.freeGiftConfig || {};

    freeGiftEnabled =
      setupEl?.dataset?.freeGiftEnabled === 'true' || cfg.enabled === true;

    excludedProductId = String(
      setupEl?.dataset?.excludedProductId || cfg.excludedProductId || '45177829228726'
    );

    giftProductId = String(
      setupEl?.dataset?.giftProductId || cfg.giftProductId || '8822071230646'
    );

    if (setupEl?.dataset?.giftVariantId) {
      giftVariantId = parseInt(setupEl.dataset.giftVariantId, 10);
    } else if (cfg.giftVariantId) {
      giftVariantId = parseInt(cfg.giftVariantId, 10);
    }

    giftDiscountCode = (setupEl?.dataset?.giftDiscountCode || cfg.giftDiscountCode || '').trim();
  }

  function getApplicableDiscountCodes(cart) {
    return (cart.discount_codes || [])
      .filter(function (entry) {
        return entry.applicable;
      })
      .map(function (entry) {
        return entry.code;
      });
  }

  function isDiscountCodeApplied(cart, code) {
    if (!code) {
      return true;
    }

    var normalized = code.toLowerCase();

    return getApplicableDiscountCodes(cart).some(function (appliedCode) {
      return appliedCode.toLowerCase() === normalized;
    });
  }

  function applyFreeGiftDiscount(cart) {
    if (!freeGiftEnabled || !giftDiscountCode) {
      return Promise.resolve(cart);
    }

    if (isDiscountCodeApplied(cart, giftDiscountCode)) {
      return Promise.resolve(cart);
    }

    var existingCodes = getApplicableDiscountCodes(cart);
    var discountValue =
      (existingCodes.length ? existingCodes.join(',') + ',' : '') + giftDiscountCode;

    console.log(LOG, 'applying discount code:', giftDiscountCode);

    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ discount: discountValue }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            console.warn(LOG, 'discount apply failed:', err);
            throw err;
          });
        }
        return res.json();
      })
      .then(function (updatedCart) {
        if (!isDiscountCodeApplied(updatedCart, giftDiscountCode)) {
          console.warn(
            LOG,
            'discount code not applicable — create Buy X get Y in Admin or set shaker price to ₹0'
          );
          return cart;
        }

        console.log(LOG, 'discount applied — cart total:', updatedCart.total_price);
        return updatedCart;
      })
      .catch(function () {
        return cart;
      });
  }

  function resolveGiftVariantId() {
    if (giftVariantId && !isNaN(giftVariantId)) {
      return Promise.resolve(giftVariantId);
    }

    console.log(LOG, 'fetching variant from /products/' + GIFT_HANDLE + '.js');

    return fetch(window.Shopify.routes.root + 'products/' + GIFT_HANDLE + '.js')
      .then(function (res) {
        if (!res.ok) {
          throw new Error('/products/' + GIFT_HANDLE + '.js returned ' + res.status);
        }
        return res.json();
      })
      .then(function (product) {
        giftVariantId = product.variants?.[0]?.id || null;
        if (window.freeGiftConfig) {
          window.freeGiftConfig.giftVariantId = giftVariantId;
        }
        console.log(LOG, 'resolved gift variant id:', giftVariantId);
        return giftVariantId;
      });
  }

  function isGiftItem(item) {
    return (
      String(item.product_id) === giftProductId ||
      item.variant_id === giftVariantId ||
      item.id === giftVariantId ||
      item.properties?.[FREE_GIFT_PROPERTY] === 'true'
    );
  }

  function cartHasTriggerProduct(items) {
    if (!freeGiftEnabled) {
      return false;
    }

    return (items || []).some(function (item) {
      return !isGiftItem(item) && !isExcludedProduct(item);
    });
  }

  function getGiftItem(items) {
    return (items || []).find(function (item) {
      return isGiftItem(item);
    });
  }

  function giftAlreadyInCart() {
    return !!getGiftItem(lastKnownCart?.items);
  }

  function getSectionsToBundle(variantId) {
    var sections = ['variant-added'];
    document.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections },
      })
    );
    return {
      sections: sections,
      sectionsUrl:
        window.Shopify.routes.root + 'variants/' + (variantId || ''),
    };
  }

  function getCartSectionsToBundle() {
    var sections = [];
    document.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections },
      })
    );
    return {
      sections: sections,
      sectionsUrl: window.location.pathname,
    };
  }

  function mergeCartSections(primarySections, secondarySections) {
    if (!secondarySections) {
      return primarySections || {};
    }

    var merged = Object.assign({}, primarySections || {});

    Object.keys(secondarySections).forEach(function (key) {
      if (key === 'variant-added') {
        return;
      }
      merged[key] = secondarySections[key];
    });

    return merged;
  }

  function buildMainLineItemFromForm(form) {
    var variantInput = form.querySelector('[name="id"]');
    var variantId = parseInt(variantInput?.value, 10);
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var item = { id: variantId, quantity: quantity };

    var sellingPlan = form.querySelector('[name="selling_plan"]');
    if (sellingPlan && sellingPlan.value) {
      item.selling_plan = parseInt(sellingPlan.value, 10);
    }

    var properties = {};
    new FormData(form).forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') {
        properties[match[1]] = value;
      }
    });

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    return item;
  }

  function setSubmitButtonsBusy(form, busy) {
    Array.from(form.elements)
      .filter(function (button) {
        return button.type === 'submit';
      })
      .forEach(function (submitButton) {
        if (busy) {
          submitButton.setAttribute('aria-busy', 'true');
        } else {
          submitButton.removeAttribute('aria-busy');
        }
      });
  }

  function publishVariantAdd(source, responseJson, cartContent, baseEvent) {
    lastKnownCart = cartContent;

    source.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
          cart: cartContent,
        },
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: baseEvent || 'variant:add',
          cart: cartContent,
        },
      })
    );

    return cartContent;
  }

  function publishCartUpdate(cartContent, baseEvent) {
    var pageType = window.themeVariables?.settings?.pageType;

    if (pageType === 'cart') {
      console.log(LOG, 'cart page — reloading');
      window.location.reload();
      return cartContent;
    }

    lastKnownCart = cartContent;

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: baseEvent || 'free-gift:sync',
          cart: cartContent,
        },
      })
    );

    return cartContent;
  }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js').then(function (res) {
      return res.json();
    });
  }

  function finalizeCartAfterAdd(responseJson) {
    return fetchCart().then(function (cartContent) {
      if (responseJson.sections) {
        cartContent.sections = responseJson.sections;
      }
      return applyFreeGiftDiscount(cartContent);
    });
  }

  function addItemsToCart(items, variantId) {
    var bundle = getSectionsToBundle(variantId);

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: items,
        sections: bundle.sections.join(','),
        sections_url: bundle.sectionsUrl,
      }),
    }).then(function (res) {
      return res.json().then(function (responseJson) {
        if (!res.ok) {
          console.error(LOG, 'add items failed:', responseJson);
          throw responseJson;
        }
        return responseJson;
      });
    });
  }

  function addGift() {
    if (!freeGiftEnabled) {
      return Promise.resolve();
    }

    return tryAddGiftToCart().then(function (giftResponse) {
      if (!giftResponse) {
        return fetchCart();
      }

      return fetchCart().then(function (cart) {
        var triggerVariantId = getTriggerVariantIdFromCart(cart);

        if (!triggerVariantId) {
          return finalizeCartAfterAdd({ sections: giftResponse.sections }).then(function (updatedCart) {
            return publishCartUpdate(updatedCart);
          });
        }

        return refreshVariantAddedSection({ sections: giftResponse.sections || {} }, triggerVariantId).then(
          function (holder) {
            if (holder.sections && holder.sections['variant-added']) {
              updateCartNotificationFromVariantAdded(holder.sections['variant-added']);
            }

            return finalizeCartAfterAdd(holder).then(function (updatedCart) {
              if (holder.sections) {
                updatedCart.sections = Object.assign(updatedCart.sections || {}, holder.sections);
              }
              return publishCartUpdate(updatedCart);
            });
          }
        );
      });
    });
  }

  function addTriggerProductWithGift(form) {
    if (!freeGiftEnabled || !ready || processing || !giftVariantId) {
      return Promise.resolve(null);
    }

    if (giftAlreadyInCart()) {
      return Promise.resolve(null);
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return Promise.resolve();
    }

    var mainItem = buildMainLineItemFromForm(form);
    if (!mainItem.id || isNaN(mainItem.id)) {
      return Promise.resolve();
    }

    processing = true;
    setSubmitButtonsBusy(form, true);

    console.log(LOG, 'add main product first, then try free gift');

    return addItemsToCart([mainItem], mainItem.id)
      .then(function (mainResponseJson) {
        if (giftAddDisabled) {
          return completeMainProductAdd(form, mainResponseJson, mainItem.id);
        }

        return tryAddGiftToCart().then(function (giftResponse) {
          if (giftResponse && giftResponse.sections) {
            mainResponseJson.sections = mergeCartSections(
              mainResponseJson.sections,
              giftResponse.sections
            );
          }
          return completeMainProductAdd(form, mainResponseJson, mainItem.id);
        });
      })
      .catch(function (error) {
        console.error(LOG, 'main product add failed:', error);
        form.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: {
              error: error?.description || error?.message || 'Could not add to cart',
            },
          })
        );
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .finally(function () {
        processing = false;
        setSubmitButtonsBusy(form, false);
      });
  }

  function removeGift(giftItem) {
    var bundle = getSectionsToBundle();

    console.log(LOG, 'removing gift — trigger product not in cart');

    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: giftItem.key,
        quantity: 0,
        sections: bundle.sections.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            console.error(LOG, 'remove gift failed:', err);
            throw err;
          });
        }
        return res.json();
      })
      .then(function (response) {
        console.log(LOG, 'gift removed from cart');
        if (response.sections) {
          return publishCartUpdate(response);
        }
        return fetchCart().then(publishCartUpdate);
      });
  }

  function syncCart(allowAdd, knownCart) {
    if (!ready || processing || !giftVariantId) {
      return Promise.resolve();
    }

    processing = true;

    var cartPromise = knownCart ? Promise.resolve(knownCart) : fetchCart();

    return cartPromise
      .then(function (cart) {
        lastKnownCart = cart;

        var hasTrigger = cartHasTriggerProduct(cart.items);
        var giftItem = getGiftItem(cart.items);

        console.log(
          LOG,
          'sync — trigger in cart:',
          hasTrigger,
          '| gift in cart:',
          !!giftItem,
          '| allowAdd:',
          allowAdd
        );

        if (!hasTrigger && giftItem) {
          return removeGift(giftItem);
        }

        if (hasTrigger && !giftItem && allowAdd) {
          return addGift();
        }

        if (
          hasTrigger &&
          giftItem &&
          giftDiscountCode &&
          !isDiscountCodeApplied(cart, giftDiscountCode)
        ) {
          return applyFreeGiftDiscount(cart).then(function (discountedCart) {
            if (discountedCart !== cart) {
              return publishCartUpdate(discountedCart);
            }
            return cart;
          });
        }

        return cart;
      })
      .finally(function () {
        processing = false;
      });
  }

  function onProductFormSubmit(event) {
    if (!freeGiftEnabled || !ready || !giftVariantId || processing) {
      return;
    }

    if (!window.freeGiftConfig?.isTriggerProductPage) {
      return;
    }

    if (giftAlreadyInCart()) {
      return;
    }

    var form = event.target;
    if (!form || form.getAttribute('is') !== 'product-form') {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    addTriggerProductWithGift(form);
  }

  function onCartChange(event) {
    if (!ready) {
      return;
    }

    var base = event.detail?.baseEvent;
    if (base === 'free-gift:sync') {
      return;
    }

    if (event.detail?.cart) {
      lastKnownCart = event.detail.cart;
    }

    console.log(LOG, 'cart:change —', base);

    if (base === 'variant:add') {
      var cart = event.detail?.cart;
      if (cart && cartHasTriggerProduct(cart.items) && getGiftItem(cart.items)) {
        return;
      }
      syncCart(true, cart);
      return;
    }

    if (base === 'line-item:change' || base === 'customMagicAddToCart') {
      syncCart(false);
      return;
    }

    syncCart(false);
  }

  function init() {
    readConfig();

    document.documentElement.addEventListener(
      'cart:change',
      function (event) {
        if (event.detail?.cart) {
          lastKnownCart = event.detail.cart;
        }
      },
      true
    );

    document.addEventListener('submit', onProductFormSubmit, true);

    resolveGiftVariantId()
      .then(function (id) {
        if (!id || isNaN(id)) {
          console.warn(LOG, 'gift variant ID not set — Theme settings > Cart > Free gift variant ID');
          return;
        }

        giftVariantId = id;
        ready = true;

        document.documentElement.addEventListener('cart:change', onCartChange);

        window.syncFreeGiftForProduct = function () {
          return syncCart(true);
        };

        window.addFreeGiftBundleToCart = function (form) {
          return addTriggerProductWithGift(form);
        };

        console.log(LOG, 'ready — free gift disabled | excluded product:', excludedProductId, '| gift variant:', giftVariantId);

        return fetchCart().then(function (cart) {
          lastKnownCart = cart;
          return syncCart(false, cart);
        });
      })
      .catch(function (err) {
        console.error(LOG, 'init failed:', err.message);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
